
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

export class TextCanvasConfig {
    minFontSize: number
    maxFontSize: number
    lineHeight: number
    width: number
    height: number
    font: string
    maxLineCount: number
    fontWeight: string

    constructor(minFontSize: number, maxFontSize: number, lineHeight: number, width: number, height: number, font: string, maxLineCount: number, fontWeight: string) {
        this.minFontSize = minFontSize
        this.maxFontSize = maxFontSize
        this.lineHeight = lineHeight
        this.width = width
        this.height = height
        this.font = font
        this.maxLineCount = maxLineCount
        this.fontWeight = fontWeight
    }
}

export class TextResult {
    text: string
    size: number
    cutInputCount: number

    constructor() {
        this.text = ""
        this.size = 0
        this.cutInputCount = 0
    }
}

@Component({
    name: 'text-canvas'
})
export default class TextCanvas extends Vue {

    @Prop({})
    config!: TextCanvasConfig

    private currentFontSize: number = 35
    private canvas: HTMLCanvasElement = this.$refs.textCanvas
    private context: CanvasRenderingContext2D = {} as CanvasRenderingContext2D

    mounted () {
        this.currentFontSize = this.config.maxFontSize
        this.canvas = this.$refs.textCanvas
        this.context = this.canvas.getContext("2d")!
    }

    $refs!: {
        textCanvas: HTMLCanvasElement
    }

    fitTextOnCanvas(text: string) {
        var textResult = new TextResult()
        if(text) {
            var lines = text.split("\n", this.config.maxLineCount)
            this.currentFontSize = this.calculateMaxFontSize(lines.length)
            this.context!.font = this.getFont(this.currentFontSize)
            for(var i = 0; i < lines.length; i++) {
                var line = lines[i]
                if(this.doesLineFitOnCanvasWithMinFontSize(line)) {
                    this.findMaxPosibleFontSize(line)
                } else {
                    textResult.cutInputCount = this.makeLineFit(line, lines, i)
                    line = lines[i]
                    this.findMaxPosibleFontSize(line)
                }
            }
            
            textResult.text = this.buildTextResult(lines)
            textResult.size = this.currentFontSize
        }
        return textResult
    }

    findMaxPosibleFontSize(line: string) {
        while(!this.doesLineFitOnCanvas(line)) {
            this.currentFontSize--
            this.context!.font = this.getFont(this.currentFontSize)
        }
    }

    doesLineFitOnCanvas(line: string) {
        if (this.context!.measureText(line).width > this.config.width) {
            return false
        }
        return true
    }

    doesLineFitOnCanvasWithMinFontSize(line: string) {
        this.context!.font = this.getFont(this.config.minFontSize)
        var result = this.doesLineFitOnCanvas(line)
        this.context!.font = this.getFont(this.currentFontSize)
        return result;
    }

    getFont(size: number) {
        return this.config.fontWeight + " " + size + "px " + this.config.font
    }

    buildTextResult(lines :string[]) {
        var result = ""
        for(var line of lines) {
            if(result.length > 0) {
                result = result + '\n' + line
            }else {
                result = line
            }
        }
        return result
    }

    makeLineFit(line: string, lines: string[], lineIndex: number) {
        var charsToRemove = 1
        if(lineIndex == this.config.maxLineCount - 1) {
            while(!this.doesLineFitOnCanvasWithMinFontSize(line.substring(0, line.length - charsToRemove))) {
                charsToRemove++
                if(charsToRemove >= line.length) break
            }
            lines[lineIndex] = line.substring(0, line.length - charsToRemove)
            return charsToRemove
        }else {
            var words = line.split(" ")
            if(words.length < 2) {
                while(!this.doesLineFitOnCanvasWithMinFontSize(line.substring(0, line.length - charsToRemove) + '-')) {
                    charsToRemove++
                    if(charsToRemove >= line.length) break
                }
                lines[lineIndex] = line.substring(0, line.length - charsToRemove) + '-'
                if(lines[lineIndex + 1] != null) {
                    lines[lineIndex + 1] = line.substring(line.length - charsToRemove) + ' ' + lines[lineIndex + 1]
                }else {
                    lines.push(line.substring(line.length - charsToRemove))
                }
            }else {
                if(words[words.length - 1].length == 0) {
                    lines[lineIndex] = line.substring(0, line.length - 1)
                }else {
                    lines[lineIndex] = line.substring(0, line.length - words[words.length - 1].length)
                }
                if(lines[lineIndex + 1] != null) {
                    lines[lineIndex + 1] = words[words.length - 1] + ' ' + lines[lineIndex + 1].trim()
                }else {
                    lines.push(words[words.length - 1])
                }
                if(!this.doesLineFitOnCanvasWithMinFontSize(lines[lineIndex])) {
                    this.makeLineFit(lines[lineIndex], lines, lineIndex)
                }
            }
        }
        return 0
    }

    calculateMaxFontSize(numberOfLines: number) {
        let max = Math.floor(this.config.height / (numberOfLines * this.config.lineHeight))
        if(max > this.config.maxFontSize) {
            return this.config.maxFontSize
        }
        return max
    }
}
